module.exports = __webpack_public_path__ + "img/tbt23-1999_4.asm.bcde4f56.jpg";